import React from 'react';

const moduleDefaultExport = module => module.default || module;

export default function asyncRoute(getComponent) {
  return class AsyncRoute extends React.Component {
    static Component = null

    state = {
      Component: AsyncRoute.Component
    }

    componentWillMount() {
      if (!this.state.Component) {
        getComponent()
          .then(moduleDefaultExport)
          .then(Component => {
            AsyncRoute.Component = Component;
            this.setState({ Component });
          });
      }
    }

    render() {
      const { Component } = this.state;
      return Component ? <Component {...this.props} /> : null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/async-route.js